module.exports = __webpack_public_path__ + "./img/cd3b33c7554ad0a21228baac0e8518d5.png";